import BaseInfForm from "../baseInfForm";
import DetailFormHead from "components/subHead/detailFormHead";
import { useTranslation } from "react-i18next";
import { useGetData } from "../service";
import NoInf from "components/noInf";
import MultilingualForm from "../multilingualForm";

export default function OptionDetail() {
  const { t } = useTranslation();

  const { baseInf, addInf } = useGetData({ modalNm: "detail" });

  return (
    <>
      <>
        {/* 기본정보 상세 */}
        <DetailFormHead title={t("row_ttl_default")} />

        {/* 로딩 페이지 추가  */}
        {!baseInf && (
          <BaseInfForm baseInf={undefined} formTyp={"read"} formId={""} />
        )}
        {/* {!baseInf && <BaseInfLoaing />} */}
        {baseInf && (
          <BaseInfForm baseInf={baseInf} formTyp={"read"} formId={""} />
        )}

        {/* 추가정보 상세 */}
        <DetailFormHead title={t("row_ttl_add_inf")} />
        <div>
          {addInf?.length !== 0 && (
            <>
              {addInf.map((inf: any) => {
                return (
                  <MultilingualForm
                    inf={inf}
                    updateAble="true"
                    formTyp={"read"}
                    formId={""}
                  />
                );
              })}
            </>
          )}
          {addInf.length === 0 && <NoInf />}
        </div>
      </>
    </>
  );
}
